
// STYLES
import './css/loader.css';

// ASSETS
import logo from '../../assets/Favicon.png';


export default function Loader() {
    return (
        <div className="loading">
            <img src={logo} id="img-loading" alt='SofChef' />
        </div>
    )
}